import { EChartPeriod } from '@aqx-core/common/api/chart';
import { socketService } from '@aqx-core/common/socket';
import { mapChartPeriodToTopicPeriod } from '@aqx-core/common/utils/chart';

import { IChartTopicMessage } from '../topics/chart';

class ChartTopicSubscription {
  public subscribe = (
    symbol: string,
    period: EChartPeriod,
    subscriptionKey: string,
    chartTopicReceiver: (payload: IChartTopicMessage | undefined) => void
  ) => {
    socketService.topics().chart.subscribe({
      period: mapChartPeriodToTopicPeriod(period),
      symbol,
      receiver: { subscriptionKey, payload: (payload) => chartTopicReceiver(payload) }
    });
  };

  public unsubscribe = (
    symbol: string,
    period: EChartPeriod,
    subscriptionKey: string,
    chartTopicReceiver: (payload: IChartTopicMessage | undefined) => void
  ) => {
    socketService.topics().chart.unsubscribe({
      period: mapChartPeriodToTopicPeriod(period),
      symbol,
      receiver: { subscriptionKey, payload: (payload) => chartTopicReceiver(payload) }
    });
  };
}

export const chartTopicSubscription = new ChartTopicSubscription();
